<template>
  <main class="about">
    <div class="container">
      <!-- Hero -->
      <section class="hero">
        <div class="hero__content">
          <h1>About PathTracer</h1>
   <p class="sub">
  Screening-focused blockchain analysis: paste a hash, get a clear visual summary and endpoint totals (exchanges, dormant).
</p>

        </div>
        <div class="hero__art" aria-hidden="true"></div>
      </section>

      <!-- Mission & What we build -->
      <section class="grid">
        <article class="card">
          <h3>Mission</h3>
       <p>
  Provide fast, reliable screening-grade clarity so teams can quickly research the likely destinations of assets.
</p>

        </article>

        <article class="card">
          <h3>What we build</h3>
     <ul class="checklist">
  <li>Quick visual screening from a tx hash or address</li>
  <li>Endpoint category totals (exchanges, dormant)</li>
  <li>Supported networks: BTC, ETH, Tron</li>
  <li>Smart prompts (e.g., guided "To Address" when recipients are ambiguous)</li>
</ul>

        </article>

        <article class="card">
          <h3>Support</h3>
          <p>In-app FAQ and support available</p>
       <router-link class="btn btn--ghost" to="/support" 
  data-track="open_support_from_aboutpage"
  :data-track-props="JSON.stringify({ source:'about page' })">Open Support</router-link>
        </article>
      </section>

      <!-- Company / Attribution -->
      <section class="card card--meta">
        <div class="meta__cols">
          <div>
            <h4>Product</h4>
            <p>Screening-first blockchain analysis: visual reports and endpoint totals to research the likely destinations of assets.</p>

          </div>
          <div class="meta__divider" aria-hidden="true"></div>
          <div>
            <h4>Attribution</h4>
            <p>PathTracer is distributed by CoinStructive Inc.</p>
            <p>© 2025</p>
          </div>
          <div class="meta__divider" aria-hidden="true"></div>
          <div>
            <h4>Technology</h4>
          <!--<p>PathTracer uses the Crypto WayFinder/WeiFinder Tracing Software API Mortality Core Games Inc. © 2024-2025</p>
            <p>Powered by Unity, licensed by Unity Pro.</p>-->  
            <p>Distributed by CoinStructive Inc. under agreement.</p>
          </div>
        </div>
      </section>
<section class="card" style="margin-top:1rem">
  <p style="margin:0; color: var(--muted);">
    PathTracer provides rapid screening and visual summaries. It is not a full end-to-end investigation suite (yet).
  </p>
</section>

      <!-- Policies -->
      <section class="card card--policies">
        <div class="card__header">
          <h2>Policies</h2>
        </div>
        <ul class="linklist">
          <li><router-link :to="{ name: 'PrivacyPolicy' }"
  data-track="PrivacyPolicy"
  :data-track-props="JSON.stringify({ source:'about page' })">Privacy Policy</router-link></li>
          <li><router-link :to="{ name: 'TermsOfService' }"
  data-track="TermsOfService"
  :data-track-props="JSON.stringify({ source:'about page' })">Terms of Use</router-link></li>
          <li><router-link :to="{ name: 'FairUsePolicy' }"
  data-track="FairUsePolicy"
  :data-track-props="JSON.stringify({ source:'about page' })">Fair Use Policy</router-link></li>
        </ul>
      </section>
    </div>
  </main>
</template>

<script>
export default { name: 'AboutPage' }
</script>

<style scoped>
/* Page tokens to match your upgraded look */
.about {
  --bg: #f7f9fc;
  --card: #ffffff;
  --ink: #1f2a37;
  --muted: #6b7280;
  --border: #e5e8ec;
  --accent: #35495e;
  --accent-2: #2c80b4;

  color: var(--ink);
  padding: 1.25rem 1rem 2.5rem;
  background: transparent; /* no second layer */
}
.container { max-width: 1120px; margin: 0 auto; }

/* HERO */
.hero {
  position: relative;
  overflow: hidden;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff, #f3f6fb);
  border: 1px solid var(--border);
  padding: clamp(1.25rem, 3vw, 2rem);
}
.hero__content { max-width: 920px; margin: 0 auto; text-align: left; }
.hero h1 { margin: 0; font-size: clamp(1.6rem, 1.7rem + 1vw, 2.3rem); line-height: 1.15; }
.sub { margin: .5rem 0 0; color: var(--muted); max-width: 60ch; }

/* subtle decorative glow */
.hero__art {
  position: absolute;
  inset: -20% -10% auto auto;
  height: 260px; width: 480px;
  background:
    radial-gradient(260px 160px at 70% 30%, rgba(44,128,180,.16), transparent 60%),
    radial-gradient(220px 140px at 30% 70%, rgba(53,73,94,.12), transparent 60%);
  pointer-events: none;
  z-index: 0;
}

/* GRID */
.grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 1rem;
  margin-top: 1rem;
}
.card {
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 14px;
  box-shadow: 0 10px 20px rgba(16,24,40,.06);
  padding: 1.2rem;
  text-align: left;
}
.card h3 { margin: 0 0 .4rem; font-size: 1.1rem; }
.card p { margin: 0; color: var(--muted); }

/* Checklist styling */
.checklist { margin: .25rem 0 0; padding: 0; list-style: none; display: grid; gap: .4rem; }
.checklist li {
  position: relative; padding-left: 1.3rem; color: var(--ink);
}
.checklist li::before {
  content: "✓"; position: absolute; left: 0; top: 0; line-height: 1;
  color: #0b63a9; font-weight: 700;
}

/* Buttons */
.btn {
  display: inline-flex; align-items: center; justify-content: center;
  padding: .7rem .9rem; border-radius: 12px; font-weight: 700;
  text-decoration: none; border: 1px solid var(--border); color: var(--accent);
  background: #fff; transition: filter 140ms ease, box-shadow 140ms ease;
  margin-top: .6rem;
}
.btn:hover { filter: brightness(0.98); }
.btn--ghost {}

/* Meta / Company block */
.card--meta { margin-top: 1rem; }
.meta__cols {
  display: grid;
  grid-template-columns: 1fr auto 1fr auto 1fr;
  gap: 1rem;
  align-items: start;
}
.meta__divider { width: 1px; align-self: stretch; background: var(--border); border-radius: 1px; }
.card--meta h4 { margin: 0 0 .25rem; font-size: 1rem; }
.card--meta p { margin: .1rem 0; color: var(--muted); }

/* Policies */
.card--policies { margin-top: 1rem; }
.card__header { display: flex; align-items: baseline; justify-content: space-between; margin-bottom: .4rem; }
.card__header h2 { margin: 0; font-size: 1.15rem; }
.linklist { list-style: none; margin: 0; padding: 0; display: grid; gap: .35rem; }
.linklist a { color: #0b63a9; text-decoration: none; }
.linklist a:hover { text-decoration: underline; }

/* Responsive */
@media (max-width: 960px) {
  .grid { grid-template-columns: 1fr; }
  .meta__cols { grid-template-columns: 1fr; }
  .meta__divider { display: none; }
}
</style>
